import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d4401d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallets container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Derived Wallets from your Mnemonic"),
  /*#__PURE__*/_createElementVNode("p", null, "Past your Mnemonic phrase to generate the derived addresses you want")
], -1))
const _hoisted_3 = { class: "mnemonic" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-group hide" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "root-key",
  class: "col-sm-2 control-label"
}, "BIP32 Root Key", -1))
const _hoisted_7 = { class: "col-sm-10" }
const _hoisted_8 = { class: "derivation" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Derived Addresses", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " BIP32 Root Key and derivation path BIP44/BIP84 are the standards used to create deterministics wallets. ", -1))
const _hoisted_11 = { class: "mg-tabs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Day-to-day expenses", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"80px"} }, "index"),
    /*#__PURE__*/_createElementVNode("th", null, "Public"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100%"} }, "Private")
  ])
], -1))
const _hoisted_14 = { class: "private" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Slot for exchange", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Secure your financial activities", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"80px"} }, "index"),
    /*#__PURE__*/_createElementVNode("th", null, "Public"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100%"} }, "Private")
  ])
], -1))
const _hoisted_18 = { class: "private" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Slot for your pension fund", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Secure your retirement", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"80px"} }, "index"),
    /*#__PURE__*/_createElementVNode("th", null, "Public"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100%"} }, "Private")
  ])
], -1))
const _hoisted_22 = { class: "private" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("textarea", {
        value: _ctx.mnemonic,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateMnemonic && _ctx.updateMnemonic(...args))),
        class: "phrase private-data",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false"
      }, "              \n        ", 40, _hoisted_4),
      _createElementVNode("div", {
        class: _normalizeClass(["warning", {hide:!_ctx.isValidMnemonic}])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rootKey) = $event)),
          class: "root-key private-data",
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "off",
          spellcheck: "false"
        }, null, 512), [
          [_vModelText, _ctx.rootKey]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDerivation('btc'))),
            class: _normalizeClass({active:!_ctx.defaultDerivation.index})
          }, "BTC (legacy)", 2),
          _createElementVNode("li", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDerivation('segwit'))),
            class: _normalizeClass({active:_ctx.defaultDerivation.index == 1})
          }, "BTC segwit", 2),
          _createElementVNode("li", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDerivation('eth'))),
            class: _normalizeClass({active:(_ctx.defaultDerivation.index == 2)})
          }, "ETH", 2)
        ]),
        _hoisted_12,
        _createElementVNode("table", null, [
          _hoisted_13,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (wallet, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("b", null, "/" + _toDisplayString(index), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString((wallet.address)), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.address(wallet.privateKey)), 1)
              ]))
            }), 128))
          ])
        ]),
        _hoisted_15,
        _hoisted_16,
        _createElementVNode("table", null, [
          _hoisted_17,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets, (wallet, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("b", null, "/" + _toDisplayString(index+5), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString((wallet.address)), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.address(wallet.privateKey)), 1)
              ]))
            }), 128))
          ])
        ]),
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("table", null, [
          _hoisted_21,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pension, (wallet, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("b", null, "/" + _toDisplayString(index+10), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString((wallet.address)), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.address(wallet.privateKey)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}